export default "__VITE_ASSET__CZw_rkJC__"